import { Card, Flex } from 'antd';
import TagComponent from 'components/Tags';
import TaskInfo from 'components/TaskInfo';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import useSeasonByIdQuery from 'screens/awd-dashboard/hooks/queries/useSeasonByIdQuery';
import { SelectTaskData } from 'screens/sales-group-progress';
import { getStatusValues, renderDate } from 'utils/helpers';
import FarmerApdList from './farmer-apd/FarmerApdList';

const StartSeasonContent = ({ data }: { data: SelectTaskData }) => {
  const { task, season } = { ...data };
  const { text: iconText, color: iconColor } = getStatusValues(
    data?.task?.status,
  );

  const { data: seasonData, isLoading, error } = useSeasonByIdQuery(season?.id);

  const recordedFarmers = useMemo(
    () =>
      seasonData?.seasonParticipantses?.filter(
        (participant) => !!participant.actualPlantingDate,
      ),
    [seasonData?.seasonParticipantses],
  );

  const { t } = useTranslation();

  return (
    <Flex vertical gap={16}>
      <Card>
        <Flex
          wrap="wrap"
          justify="space-between"
          align="center"
          style={{ rowGap: 20 }}
        >
          <TaskInfo header={t('dashboard.taskStatus')}>
            <TagComponent label={iconText} color={iconColor} />
          </TaskInfo>

          <TaskInfo header={t('common.filters.agronomist')}>
            {data?.agronomistName}
          </TaskInfo>

          <TaskInfo header={t('dashboard.plantingGroupName')}>
            {data?.season?.name}
          </TaskInfo>

          <TaskInfo header={t('dashboard.taskTimeWindow')}>
            {renderDate(task?.dueDate)} - {renderDate(task?.endDate, 'N/A')}
          </TaskInfo>

          <TaskInfo header={t('dashboard.taskCompletionDate')}>
            {renderDate(task?.inputDate)}
          </TaskInfo>

          <TaskInfo header={t('dashboard.recordedFarmers')}>
            {recordedFarmers?.length || (isLoading ? '-' : 0)} /{' '}
            {seasonData?.seasonParticipantses?.length || (isLoading ? '-' : 0)}
          </TaskInfo>
        </Flex>
      </Card>

      <FarmerApdList
        taskAssignmentId={task?.id!}
        farmers={recordedFarmers}
        isLoading={isLoading}
        error={error}
      />
    </Flex>
  );
};

export default StartSeasonContent;
